<template>
	<div>
		{{ stylist.shortened_name }}
	</div>
</template>

<script>
export default {
  props: [
    'stylist'
  ]
}
</script>
